import React from 'react';
import './styles.css';

export interface BaseCardProps {
  variant?: 'list' | 'detail' | 'stat';
  hover?: boolean;
  className?: string;
  children: React.ReactNode;
}

const BaseCard: React.FC<BaseCardProps> = ({
  variant = 'list',
  hover = true,
  className = '',
  children
}) => {
  const cardClassName = [
    'card',
    `card-${variant}`,
    hover ? 'card-hover' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClassName}>
      {children}
    </div>
  );
};

export default BaseCard; 